import React from "react";
import { FaDownload, FaSpinner } from "react-icons/fa";
import { toast } from "react-hot-toast";

const CSVDownloadButton = ({
  data,
  fields,
  headers,
  filename,
  label = "CSV",
  isLoading = false,
  className = "",
}) => {
  // Convert data to CSV format
  const convertToCSV = (data, fields, headers) => {
    // Add headers
    let csv = headers.join(',') + '\n';
    
    // Add data rows
    data.forEach(item => {
      const row = fields.map(field => {
        const value = typeof field === 'function' ? field(item) : item[field];
        // Handle string values that might contain commas
        if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value || '';
      });
      csv += row.join(',') + '\n';
    });
    
    return csv;
  };

  // Handle download click
  const handleDownload = () => {
    if (isLoading || !data || data.length === 0) {
      toast.error("No data available to download");
      return;
    }

    // Convert data to CSV
    const csv = convertToCSV(data, fields, headers);
    
    // Create blob and download
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    // Create hidden link and trigger download
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    toast.success(`Data downloaded successfully as ${filename}`);
  };

  return (
    <button
      onClick={handleDownload}
      className={`bg-jacarta-700 text-white px-3 py-2 rounded-md flex items-center hover:bg-jacarta-600 transition-colors ${className}`}
      title="Download as CSV"
      disabled={isLoading || !data || data.length === 0}
    >
      {isLoading ? (
        <FaSpinner className="animate-spin mr-1" />
      ) : (
        <FaDownload className="mr-1" />
      )}
      {label}
    </button>
  );
};

export default CSVDownloadButton;